import { render, staticRenderFns } from "./DetailsIncidents.vue?vue&type=template&id=ad04a6f4&"
import script from "./DetailsIncidents.vue?vue&type=script&lang=js&"
export * from "./DetailsIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports